const getUuid = () => {
    const uuid = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 32; i += 1) {
        uuid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    uuid[12] = '4';
    // eslint-disable-next-line no-bitwise
    uuid[16] = hexDigits.substr(uuid[16] | 0x8, 1);
    // uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    return uuid.join('');
};
/**
 * 获取上级公用域名
 * @returns
 */
const getToperDomain = () => {
    const hostName = window.location.hostname;
    // 第一个.的索引值
    const firstIndexOfDot = hostName.indexOf('.');
    // 公用cookie域名
    const publicCookieHostName = firstIndexOfDot === -1 ? hostName : hostName.slice(firstIndexOfDot);
    return publicCookieHostName;
};export{getToperDomain,getUuid};//# sourceMappingURL=utils.js.map
